import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { MapMenuCode } from 'src/app/feature/map-viewer/map-menus/map-menu-list';

@Injectable({
    providedIn: 'root'
})
export class MenuService {
    activeMenusStream = new BehaviorSubject<MapMenuCode[]>([]);
    previousActiveMenusStream = new BehaviorSubject<MapMenuCode[]>([]);

    setActiveMenus(newActiveMenus: MapMenuCode[]): void {
        this.activeMenusStream.next(newActiveMenus);
    }

    openPreviousActiveMenus(): void {
        this.activeMenusStream.next(this.previousActiveMenusStream.value);
    }

    closeActiveMenus(): void {
        this.activeMenusStream.next([]);
    }
}
